// extracted by mini-css-extract-plugin
export var cardIcon = "_9q-4";
export var checkboxCard = "_9q-0";
export var checkboxCardSelected = "_9q-1";
export var disabled = "_9q-2";
export var outerBorder = "_9q-3";
export var spacerMedium = "_9q-7";
export var spacerSmall = "_9q-6";
export var spacerXsmall = "_9q-5";